import { Box, Link, Paper, Typography } from '@mui/material';
import { NavLinkComponent } from '../../Router';
import { DataListComponent, NoDataPaper } from '../../components/data/DataTable';
import { House } from '../../models/Types';
import { moneyFormat } from '../../utils';
import { inhabitantStore } from '../inhabitants/InhabitantCombo';


const styles = {
    mobileIconWrapper: {
        p: .66,
        display: 'flex',
        borderRadius: .5
    },
    mobileListItem: {
        display: 'flex',
        flexDirection: 'row!important',
        justifyContent: 'space-between',
        textDecoration: 'none',
        p: 2,
        gap: 2,
        alignItems: 'flex-start'
    }
}

export function buildHouseListItem(x: House) {
    return <Paper component={NavLinkComponent} sx={styles.mobileListItem} elevation={2} route={[['id', x.Id]]}>
        <Box>
            <Link variant="h3">{x.Street}, {x.Number}</Link>
            <Typography variant="subtitle2">{inhabitantStore.data?.find(i => i.Id == x.OwnerId)?.Value}</Typography>
        </Box>
        <Box>
            <Typography variant="h3">{moneyFormat(x.Balance)}</Typography>
        </Box>
    </Paper>;
}

export function noDataRenderer() {
    return <NoDataPaper title="Платежей пока нет" content={['В этом разделе будут отображаться платежи, поступившие в УК']} />;
}

export default class HouseList extends DataListComponent<House> {
    renderNoData() {
        return noDataRenderer();
    }

    buildItemPaper(x: House, i: number) {
        return buildHouseListItem(x);
    }
}